"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const moment = require("moment");
const react_scrollable_anchor_1 = require("react-scrollable-anchor");
const Ticket_1 = require("@dialogexe/cw-component-ticket/Ticket");
const images_1 = require("@dialogexe/cw-asset-provider/images");
const events_1 = require("@dialogexe/cw-website-store/events");
const DatePicker_1 = require("@dialogexe/cw-component-date-picker/DatePicker");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
require("moment/locale/nn");
require("moment/locale/nb");
const RATING_AGE_LIMIT = "År";
class TicketList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: {
                date: '',
                tickets: []
            },
            days: [],
            showFullDate: false
        };
        this.ShowTimeTickets = 15;
        this.getActiveTickets = () => {
            return this.props.tickets
                .filter(ticket => ticket.type !== 'movie_coming' && moment(ticket.date).startOf('day').isSameOrAfter(moment().startOf('day')));
        };
        this.filterTickets = () => {
            return this.props.tickets.filter(ticket => ticket.title);
        };
        this.onDaySelected = (e) => {
            this.setActiveDay({
                date: e.target.value
            });
        };
        this.setActiveDay = (day) => {
            const date = day ? day.date : null;
            this.setState({
                active: {
                    date: date,
                    tickets: this.props.tickets.filter(e => {
                        return moment(e.date).isSame(date, 'day') && e.type !== 'movie_coming';
                    })
                }
            });
        };
        const preferredLanguage = props.preferredLanguage ? props.preferredLanguage : 'nb';
        moment.locale(preferredLanguage);
    }
    componentDidMount() {
        this.props.eventActions.fetchEvents(this.props.tickets.map(t => t.id));
        const tickets = this.filterTickets();
        const days = tickets.reduce((days, next) => {
            if (days.find(day => (this.isSameFromDay(next.date, day.date)))) {
                return days;
            }
            if (moment(next.date).startOf('day').isSameOrAfter(moment().startOf('day'))) {
                days.push({
                    date: next.date
                });
            }
            return days;
        }, []);
        days.sort((day1, day2) => {
            return moment(day1.date).diff(moment(day2.date), 'hours');
        });
        const activeDay = this.resolveActiveDay(days);
        const activeTickets = this.getActiveTickets();
        this.setState({
            days: days.sort(),
            showFullDate: activeTickets.length <= this.ShowTimeTickets
        }, () => this.setActiveDay(activeDay));
    }
    render() {
        const { title, club, preferredLanguage } = this.props;
        const activeTickets = this.getActiveTickets();
        const tickets = this.getTickets(activeTickets);
        return (React.createElement(react_scrollable_anchor_1.default, { id: 'tickets' },
            React.createElement("div", { className: "TicketList" },
                React.createElement("h1", { className: "title" }, title),
                club && preferredLanguage == "nn" ?
                    React.createElement("div", { className: "club-stripe" },
                        React.createElement("div", { className: "expanded" },
                            React.createElement("span", { className: "hidden-mobile" }, "Denne filmen kan du sj\u00E5 p\u00E5 kino til 50% for"),
                            React.createElement("span", null,
                                React.createElement("img", { src: images_1.kinoklubbBlackImage, alt: "kinoklubb" })),
                            React.createElement("span", { className: "hidden-mobile" }, "-medlemar")),
                        React.createElement("div", null,
                            React.createElement("a", { href: "https://www.kinoklubb.no", target: "_blank" }, "Les meir")))
                    : club &&
                        React.createElement("div", { className: "club-stripe" },
                            React.createElement("div", { className: "expanded" },
                                React.createElement("span", { className: "hidden-mobile" }, "Denne filmen kan sees p\u00E5 kino til 50% for"),
                                React.createElement("span", null,
                                    React.createElement("img", { src: images_1.kinoklubbBlackImage, alt: "kinoklubb" })),
                                React.createElement("span", { className: "hidden-mobile" }, "-medlemmer")),
                            React.createElement("div", null,
                                React.createElement("a", { href: "https://www.kinoklubb.no", target: "_blank" }, "Les mer"))),
                this.props.type === 'movie_coming' && tickets.every(ticket => !ticket.title) ? (React.createElement("div", { className: "filter" },
                    React.createElement("p", null, "Billetter blir lagt ut i god tid f\u00F8r premieren"))) : (this.renderFilter(activeTickets)),
                React.createElement("div", { className: "tickets" },
                    React.createElement("div", { className: `row is-spaced` }, tickets.map((ticket, index) => (React.createElement("div", { key: index, className: "column is-xs-12 is-md-12 is-lg-4" },
                        React.createElement(Ticket_1.Ticket, { title: ticket.title, date: ticket.date, link: ticket.purchaseUrl ? ticket.purchaseUrl : ticket.link, features: this.filterFeatures(ticket.features), count: ticket.count, salesActive: ticket.salesActive, salesEnabled: ticket.salesEnabled, ticketSaleWebEndDate: ticket.ticketSaleWebEndDate, countLow: ticket.countLow, ticketDisplayMode: this.props.ticketDisplayMode, adFlags: ticket.adFlags, adFlagsView: ticket.adFlagsView, showFullDate: this.state.showFullDate, preferredLanguage: preferredLanguage, ticketSaleType: ticket.ticketSaleType, ticketSaleWebStartDate: ticket.ticketSaleWebStartDateRealTime ? ticket.ticketSaleWebStartDateRealTime : ticket.ticketSaleWebStartDate, eventTitle: ticket.eventTitle, category: ticket.category, highlightHeading: ticket.highlightHeading, highlightBody: ticket.highlightBody })))))))));
    }
    renderFilter(activeTickets) {
        if (activeTickets.length > this.ShowTimeTickets) {
            return (React.createElement("div", { className: "filter-show" },
                this.renderDatePicker(),
                this.renderDropDown()));
        }
    }
    renderDatePicker() {
        const { active, days } = this.state;
        return (React.createElement(DatePicker_1.DatePicker, { days: days, active: active, setActiveDay: this.setActiveDay }));
    }
    renderDropDown() {
        const { days, active } = this.state;
        return (React.createElement("nav", { className: "drop-down-filter" },
            React.createElement("div", { className: "input is-wide" },
                React.createElement("select", { onChange: this.onDaySelected, value: active.date }, days.map((day, index) => (React.createElement("option", { key: index, value: day.date }, moment(day.date).format('dddd DD. MMMM YYYY'))))),
                React.createElement("i", null,
                    React.createElement("img", { src: icons_1.arrowheadDownIcon, alt: "" })))));
    }
    /* This is just a quick fix, to filter out rating_age_limit from this component
    *  "År" is expected to be part of a feature value
    *  TODO: cw-sync need to change to key/value instead of only array  of values */
    filterFeatures(features) {
        return features.filter(feature => feature.name.indexOf(RATING_AGE_LIMIT) === -1);
    }
    getTickets(activeTickets) {
        return activeTickets.length > this.ShowTimeTickets
            ? this.sortTicketsByDate(this.state.active.tickets)
            : this.sortTicketsByDate(activeTickets);
    }
    sortTicketsByDate(tickets) {
        return tickets.sort((ticket1, ticket2) => moment(ticket1.date).unix() - moment(ticket2.date).unix());
    }
    resolveActiveDay(days) {
        if (days.length === 0) {
            return null;
        }
        let urlDateParam = null;
        if (typeof window !== 'undefined') {
            const url = new URL(window.location.href);
            urlDateParam = url.searchParams.get("cw-movie-info-from");
        }
        let activeDay = null;
        if (urlDateParam) {
            activeDay = days.find((day) => (this.formatDateFromDay(day.date) === urlDateParam));
        }
        return activeDay ? activeDay : days[0];
    }
    isSameFromDay(date1, date2) {
        return this.formatDateFromDay(date1) === this.formatDateFromDay(date2);
    }
    formatDateFromDay(date) {
        return moment(date).format('YYYY-MM-DD');
    }
}
exports.TicketList = TicketList;
function merge(newEvents, currentEvents) {
    if (newEvents.length === 0) {
        return currentEvents;
    }
    return currentEvents.map(e => {
        const newTicket = newEvents.find(ne => ne.key === e.id);
        if (!newTicket) {
            return e;
        }
        e.count = newTicket.ticket_left_count;
        e.countLow = newTicket.almost_sold_out;
        e.salesEnabled = newTicket.ticket_sales_enabled;
        e.salesActive = newTicket.ticket_sales_active;
        e.ticketSaleWebStartDateRealTime = newTicket.ticket_sales_begin;
        e.ticketSaleWebEndDate = newTicket.ticket_sales_end;
        e.purchaseUrl = newTicket.purchase_url;
        return e;
    });
}
exports.default = react_redux_1.connect((state, ownProps) => ({
    events: merge(state.events.items, ownProps.tickets)
}), (dispatch) => ({
    eventActions: redux_1.bindActionCreators(events_1.actionCreators, dispatch)
}))(TicketList);



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-ticket-list/TicketList.tsx